import app from '@/js/app.js';
import { NOTIFICATION_DURATION } from '@/js/const/index.js';

const notify = ({
  icon = "<img width='18' height='18' src='static/logoIcon.png'>",
  title = 'Reallang',
  titleRightText = 'now',
  subtitle = '',
  text = '',
  duration = NOTIFICATION_DURATION,
}) => {
  app.$f7.notification
    .create({
      icon: icon,
      title: title,
      titleRightText: titleRightText,
      subtitle: subtitle,
      text: text,
      closeTimeout: duration,
    })
    .open();
};

export default notify;
